import { animation } from "./_animation";
import { common } from "./_common";
import { drawer } from "./_drawer";
import { customSplide } from "./_splide";
import { modal } from "./_modal";
// import { form } from "./_form";

animation();
common();
drawer();
customSplide();
modal();
// form();
